// myapp/src/components/common/Analytics.jsx
import { useEffect } from 'react';

const Analytics = () => {
  useEffect(() => {
    // 1. Load Google Analytics 4
    const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (gaId && gaId !== 'G-XXXXXXXXXX') {
      // Create and inject GA4 script tags
      const scriptUrl = document.createElement('script');
      scriptUrl.async = true;
      scriptUrl.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(scriptUrl);

      const scriptCode = document.createElement('script');
      scriptCode.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}', { page_path: window.location.pathname });
      `;
      document.head.appendChild(scriptCode);
    }

    // 2. Load Microsoft Clarity
    const clarityId = process.env.REACT_APP_CLARITY_PROJECT_ID;
    if (clarityId && clarityId !== 'xxxxxxxxxx') {
      const scriptClarity = document.createElement('script');
      scriptClarity.innerHTML = `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${clarityId}");
      `;
      document.head.appendChild(scriptClarity);
    }
  }, []);

  return null;
};

export default Analytics;
